module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Rizzolo Guitars","short_name":"Rizzolo Guitars","start_url":"/","background_color":"#312C29","theme_color":"#ECD1BA","display":"standalone","icon":"./static/favicon--circle--light-512px.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-62255105-2","head":false,"anonymize":true,"pageTransitionDelay":800,"defer":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[],"injectPageProps":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
